import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import { Bar, Line, Doughnut, Pie } from 'react-chartjs-2';
import './Dashboard.css'; // Import the CSS file for layout styling

// Register the required components
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

const Dashboard = () => {
    // Dummy data for the charts 
    const projectData = {
        labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        datasets: [
            {
                label: 'Projects Completed',
                data: [1, 2, 3, 4, 5, 6],
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    const skillData = {
        labels: ['JavaScript', 'React', 'Node.js', 'CSS', 'HTML'],
        datasets: [
            {
                data: [80, 90, 75, 85, 95], // Skill proficiency in percentage
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#FF9F40'],
            },
        ],
    };

    const projectTypeData = {
        labels: ['Web Development', 'Mobile App', 'Design', 'Other'],
        datasets: [
            {
                data: [50, 30, 15, 5],
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
            },
        ],
    };

    return (
        <div className="dashboard-container">
            <h2 className="dashboard-title">Portfolio Dashboard</h2>
            <div className="dashboard-charts">
                <div className="chart-container">
                    <Bar data={projectData} options={{ responsive: true }} />
                    <p className="chart-title">Projects Completed Over Time</p>
                </div>
                <div className="chart-container">
                    <Line data={projectData} options={{ responsive: true }} />
                    <p className="chart-title">Project Completion Growth</p>
                </div>
                <div className="chart-container">
                    <Doughnut data={skillData} options={{ responsive: true }} />
                    <p className="chart-title">Skill Proficiency</p>
                </div>
                <div className="chart-container">
                    <Pie data={projectTypeData} options={{ responsive: true }} />
                    <p className="chart-title">Types of Projects</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;

